/**
 * ![amber 50](https://mui.com/static/colors-preview/amber-50-24x24.png) ![amber 100](https://mui.com/static/colors-preview/amber-100-24x24.png) ![amber 200](https://mui.com/static/colors-preview/amber-200-24x24.png) ![amber 300](https://mui.com/static/colors-preview/amber-300-24x24.png) ![amber 400](https://mui.com/static/colors-preview/amber-400-24x24.png) ![amber 500](https://mui.com/static/colors-preview/amber-500-24x24.png) ![amber 600](https://mui.com/static/colors-preview/amber-600-24x24.png) ![amber 700](https://mui.com/static/colors-preview/amber-700-24x24.png) ![amber 800](https://mui.com/static/colors-preview/amber-800-24x24.png) ![amber 900](https://mui.com/static/colors-preview/amber-900-24x24.png) ![amber A100](https://mui.com/static/colors-preview/amber-A100-24x24.png) ![amber A200](https://mui.com/static/colors-preview/amber-A200-24x24.png) ![amber A400](https://mui.com/static/colors-preview/amber-A400-24x24.png) ![amber A700](https://mui.com/static/colors-preview/amber-A700-24x24.png)
 */
const amber = {
  /**
   * Preview: ![amber 50](https://mui.com/static/colors-preview/amber-50-24x24.png)
   */
  50: '#fff8e1',
  /**
   * Preview: ![amber 100](https://mui.com/static/colors-preview/amber-100-24x24.png)
   */
  100: '#ffecb3',
  /**
   * Preview: ![amber 200](https://mui.com/static/colors-preview/amber-200-24x24.png)
   */
  200: '#ffe082',
  /**
   * Preview: ![amber 300](https://mui.com/static/colors-preview/amber-300-24x24.png)
   */
  300: '#ffd54f',
  /**
   * Preview: ![amber 400](https://mui.com/static/colors-preview/amber-400-24x24.png)
   */
  400: '#ffca28',
  /**
   * Preview: ![amber 500](https://mui.com/static/colors-preview/amber-500-24x24.png)
   */
  500: '#ffc107',
  /**
   * Preview: ![amber 600](https://mui.com/static/colors-preview/amber-600-24x24.png)
   */
  600: '#ffb300',
  /**
   * Preview: ![amber 700](https://mui.com/static/colors-preview/amber-700-24x24.png)
   */
  700: '#ffa000',
  /**
   * Preview: ![amber 800](https://mui.com/static/colors-preview/amber-800-24x24.png)
   */
  800: '#ff8f00',
  /**
   * Preview: ![amber 900](https://mui.com/static/colors-preview/amber-900-24x24.png)
   */
  900: '#ff6f00',
  /**
   * Preview: ![amber A100](https://mui.com/static/colors-preview/amber-A100-24x24.png)
   */
  A100: '#ffe57f',
  /**
   * Preview: ![amber A200](https://mui.com/static/colors-preview/amber-A200-24x24.png)
   */
  A200: '#ffd740',
  /**
   * Preview: ![amber A400](https://mui.com/static/colors-preview/amber-A400-24x24.png)
   */
  A400: '#ffc400',
  /**
   * Preview: ![amber A700](https://mui.com/static/colors-preview/amber-A700-24x24.png)
   */
  A700: '#ffab00',
} as const;

export default amber;
